import React, { useState, useEffect } from "react";
import VerticalRegistry from "../../constants/verticalRegistry";
import SingleSelect from "../../widgets/Dropdown/SingleSelectDropdown";
import SearchCard from "../../widgets/SearchCard/SearchCard";
import styles from "./Home.module.scss";

const HomeComponent = ({ formik }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    setFieldValue,
    errors,
    touched,
    handleBlur,
    isSubmitting,
  } = formik;

  const [activeCard, setActiveCard] = useState(null);

  const searchCardConfig = [
    {
      key: "uam_id",
      label: "Search by UAM ID",
      placeholder: "Enter UAM ID",
    },
    {
      key: "phone",
      label: "Search by Phone Number",
      placeholder: "Enter Phone Number",
    },
    {
      key: "admission_number",
      label: "Search by Admission Number",
      placeholder: "Enter Admission Number",
    },
  ];

  const verticalObj = VerticalRegistry.getVerticalByName(values.vertical);
  const selectedConfig = verticalObj?.searchConfig || {};

  useEffect(() => {
    if (!values.vertical) {
      setActiveCard(null);
      return;
    }

    const config = VerticalRegistry.getVerticalByName(
      values.vertical,
    )?.searchConfig;

    if (config) {
      const firstEnabled = Object.keys(config).find(
        (key) => config[key] === true,
      );
      setActiveCard(firstEnabled || null);
    }
    setFieldValue("uam_id", "");
    setFieldValue("phone", "");
    setFieldValue("admission_number", "");
  }, [values.vertical, setFieldValue]);

  const handleTabChange = (key) => {
    setActiveCard(key);
    setFieldValue("uam_id", "");
    setFieldValue("phone", "");

    setFieldValue("admission_number", "");
  };

  const verticalOptions = VerticalRegistry.getAllVerticals().map((v) => v.name);

  return (
    <div className={styles.homeWrapper}>
      <div className={styles.card}>
        <form onSubmit={handleSubmit}>
          <SingleSelect
            label="Select Business Vertical"
            name="vertical"
            value={values.vertical}
            onChange={handleChange}
            options={verticalOptions}
          />

          <SearchCard
            tabs={searchCardConfig}
            activeCard={activeCard}
            setActiveCard={handleTabChange}
            config={selectedConfig}
            values={values}
            handleChange={handleChange}
            errors={errors}
            touched={touched}
            handleBlur={handleBlur}
            isLoading={isSubmitting}
          />
        </form>
      </div>
    </div>
  );
};

export default HomeComponent;
